export const columnsDataDevelopment = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "TECH",
    accessor: "tech",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];

export const columnsDataCheck = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
];

export const columnsDataColumns = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
];

export const columnsDataComplex = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "REGO",
    accessor: "rego",
  },
  {
    Header: "VIN NUMBER",
    accessor: "vinNumber",
  },
  {
    Header: "MODEL",
    accessor: "model",
  },
  {
    Header: "YEAR",
    accessor: "year",
  },
  {
    Header: "CATEGORY",
    accessor: "category",
  },
  {
    Header: "TYPE",
    accessor: "type",
  },
  {
    Header: "MOBILE NUMBER",
    accessor: "mobileNumber",
  },
  {
    Header: "STATUS",
    accessor: "status",
  },
  {
    Header: "OPTIONs",
    accessor: "options",
  },
];
